export default __webpack_public_path__ + "static/media/twinCities4.087fe79c.webp";